import { Icon } from "../components/Icon";
import { OwnerEmpty } from "../shell/OwnerEmpty";
import { PageHead } from "../shell/PageHead";
import { greeting } from "./greeting";

/** Shown only after the current account's directory has confirmed no Agents. */
export function FirstWorkspace({ accountName = "", now }: { accountName?: string; now?: Date }) {
  return <div className="owner-page">
    <PageHead title={`${greeting(now ?? new Date())}${accountName ? `，${accountName}` : ""}`} />
    <OwnerEmpty icon="agent"
      action={<a className="btn btn-accent" href="/#/create"><Icon name="plus" size={16} />新建 IP</a>}
      quiet={<>已经在自己电脑上运行了 Agent？<a href="/#/connect">连接它</a></>}>
      带来一点想法，和它一起开始你的第一个 IP。
    </OwnerEmpty>
  </div>;
}
